import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button, InputNumber } from 'antd'
import {withTranslation} from 'react-i18next'
import alertMessage from '../../../utils/alertMessage'
const {TextArea} = Input
@inject('marketingSmsTemplateStore')
@observer
class FormModal extends Component {
  state = {
    signNum: 0,
    characterNum: 0,
    suffixNum: 0,
    strNum: 0,
    smsNum: 0,
    content: '',
    textAreaStart: 0,
    sum: 0,
    groupVal: '',
  }

  formRef = React.createRef()

  componentDidMount() {
    const {marketingSmsTemplateStore, title, type, t} = this.props
    const {detailsObj, signList, groupList} = marketingSmsTemplateStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        "marketingGroupId": detailsObj?.marketingGroupId,
        "templateName": detailsObj?.templateName,
        "signId": detailsObj?.signId,
        "templateSuffix": detailsObj?.templateSuffix,
        "sendLimit": detailsObj?.sendLimit,
        "template": detailsObj?.template,
      })
      const signNum = (`【${signList?.find(a=>a?.id===detailsObj?.signId)?.sign}】`)?.length || 0
      const characterNum = detailsObj?.template?.length || 0
      const suffixNum = t(`marketingManagement.replyWithR`)?.length || 0
      this.setState({
        signNum: signNum,
        characterNum: characterNum,
        suffixNum: type==='1' ? suffixNum : 0,
        strNum: type==='1' ? signNum + characterNum + suffixNum : signNum + characterNum,
        smsNum:  type==='1' ? (signNum + characterNum + suffixNum) > 70 ? Math.ceil((signNum + characterNum + suffixNum)/67) : 1 : (signNum + characterNum) > 70 ? Math.ceil((signNum + characterNum)/67) : 1,
        content: detailsObj?.template,
        groupVal: detailsObj?.marketingGroupId
      })
    } else {
      if(type==='1') {
        const suffixNum = t(`marketingManagement.replyWithR`)?.length || 0
        this.setState({
          suffixNum: suffixNum,
          strNum: suffixNum,
          smsNum: 1
        })
        this.formRef.current.setFieldsValue({
          'templateSuffix': t(`marketingManagement.replyWithR`),
        })
      }
    }
  }

  handleOk = () => {
    const {marketingSmsTemplateStore, handleCancel, title, type} = this.props
    const {detailsObj} = marketingSmsTemplateStore
    this.formRef.current.validateFields().then(fieldsValue => {
      if(fieldsValue?.template) {
        let params = {
          "id": title === 'edit' ? detailsObj?.id : null,
          "templateId": title === 'edit' ? detailsObj?.templateId : null,
          'templateType': type,
          "marketingGroupId": fieldsValue?.marketingGroupId,
          "templateName": fieldsValue?.templateName,
          "signId": fieldsValue?.signId,
          "templateSuffix": fieldsValue?.templateSuffix,
          "sendLimit": fieldsValue?.sendLimit,
          "template": fieldsValue?.template,
          "characterNum": this.state.strNum,
        }
        if (title === 'edit') {
          marketingSmsTemplateStore.onAddAction({...params, id: detailsObj.id}, title).then(res=> {
            if (res?.data?.code === 0) {
              handleCancel()
            }
          })
        } else {
          marketingSmsTemplateStore.onAddAction({...params}).then(res=> {
            if (res?.data?.code === 0) {
              handleCancel()
            }
          })
        }
      } else {
        alertMessage.error('信息填写不完整!')
      }
    }).catch(() => {})
  }
  onChangeGroup = value => {
    this.setState({
      groupVal: value
    })
    this.formRef.current.setFieldsValue({
      'signId': undefined,
    })
    this.onChangeSign(null,'')
  }
  onChangeSign = (e,option) => {
    const strSum = parseInt((option?.children || '').length)+parseInt(this.state.characterNum)+parseInt(this.state.suffixNum)
    this.setState({
      signNum: (option?.children || '').length,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1
    })
  }
  onChangeSuffix = (e,option) => {
    const strSum = parseInt(this.state.signNum)+parseInt(this.state.characterNum)+parseInt(option.children.length)
    this.setState({
      suffixNum: option.children.length,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1
    })
  }
  onChangeTemplate = (e) => {
    const strSum = parseInt(this.state.signNum)+parseInt(e.target.value.length)+parseInt(this.state.suffixNum)
    this.setState({
      characterNum: e.target.value.length,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      content: e.target.value
    })
  }
  onSelectTemplate = (e) => {
    this.setState({
      textAreaStart:e.target.selectionStart
    })
  }
  onChangeInsertVariable =() => {
    // const textareaDom = this.formRef.current.getFieldValue('template')
    const { content, textAreaStart } = this.state
    const start = content.substring(0, textAreaStart)
    const end = content.substring(textAreaStart)
    const arr = this.extractMissingNumbers(content)
    const idx = arr.missing.length>0 ? arr.missing[0] : arr.max + 1
    if(idx < 21) {
      const strSum = parseInt(this.state.signNum)+parseInt((`${start}{%变量${idx}%}${end}`).length)+parseInt(this.state.suffixNum)
      this.setState({
        content: `${start}{%变量${idx}%}${end}`,
        textAreaStart: this.state.textAreaStart + (`{%变量${idx}%}`).length,
        characterNum: (`${start}{%变量${idx}%}${end}`).length,
        strNum: strSum,
        smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      })
      this.formRef.current.setFieldsValue({
        'template': `${start}{%变量${idx}%}${end}`,
      })
    } else {
      alertMessage.error('最多支持20个变量!')
    }
  }
  extractMissingNumbers = (str) => {  
    // 1. 正则匹配所有变量数字  
    const numbers = [...new Set(str.match(/\d+/g)?.map(Number) || [])].sort((a, b) => a - b);
    // 2. 计算缺失数字  
    const max = numbers.length > 0 ? Math.max(...numbers) : 0;  
    const expected = Array.from({length: max}, (_, i) => i + 1);  
    const missing = expected.filter(n => !numbers.includes(n));  
    return {missing: missing, max: numbers.length>0? numbers[numbers.length-1] : 0};  
  };
  onChangeTemplateName = (value) => {
    if(value.target.value===' ') {
      this.formRef.current.setFieldsValue({
        'templateName': undefined,
      })
    }
    const val = value.target.value.replace(/\s/g, "")
    this.formRef.current.setFieldsValue({
      'templateName': val,
    })
  }
  render() {
    const { marketingSmsTemplateStore, addModalVisible, handleCancel, title, type, t } = this.props
    const { groupList, signList } = marketingSmsTemplateStore
    return (
      <>
        <Modal
          title={title === 'edit' ? type==='1' ? t(`marketingManagement.editTitleMarketing`) : t(`marketingManagement.editTitleNotice`) : 
            type==='1' ? t(`marketingManagement.addTitleMarketing`) : t(`marketingManagement.addTitleNotice`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          width={'40%'}
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={12}>
                <Form.Item name="marketingGroupId" label={t(`marketingManagement.marketingGroup`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingGroup`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } onChange={this.onChangeGroup} disabled={title === 'edit'}>
                    {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="templateName" label={t(`marketingManagement.templateName`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.templateName`)}`,
                }]} onChange={this.onChangeTemplateName}>
                  <Input maxLength={60} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="signId" label={t(`marketingManagement.prefixSignature`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.prefixSignature`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } onChange={this.onChangeSign} disabled={!this.state.groupVal || title === 'edit'}>
                    {signList?.filter(a=>a?.marketingGroupId ===this.state.groupVal)?.map(item => (<Select.Option key={item.id} value={item.id}>{`【${item.sign}】`}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              {type==='1' ? <Col span={12}>
                <Form.Item name="templateSuffix" label={t(`marketingManagement.templateSuffix`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.templateSuffix`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled onChange={this.onChangeSuffix}>
                    <Select.Option key={t(`marketingManagement.replyWithR`)} value={t(`marketingManagement.replyWithR`)}>{t(`marketingManagement.replyWithR`)}</Select.Option>
                  </Select>
                </Form.Item>
              </Col> : null}
              {/* <Col span={12}>
                <Form.Item label={t(`marketingManagement.daySendNumber`)}>
                  <Row gutter={8}>
                    <Col span={8}>
                      <Form.Item name="sendLimit" style={{marginBottom: 0}}
                        rules={[{required: false, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.daySendNumber`)}`}]}
                      >
                        <InputNumber precision={0} min={0} onChange={this.onChangeDataFlowGap} style={{width: '100%'}}
                          formatter={(text) => (/^\d+$/.test(text) ? text : text.slice(0,-1))} // 格式化输出值
                          parser={(text) => (/^\d+$/.test(text) ? text : text.slice(0,-1))} // 解析输入值
                         />
                      </Form.Item>
                    </Col>
                    <Col span={16}><div style={{lineHeight: '32px'}}>{t(`marketingManagement.tips02`)}</div></Col>
                  </Row>
                </Form.Item>
              </Col> */}
              <Col span={24}>
                <div>
                  <span style={{ color: '#ff4d4f', fontSize: '14px', marginRight: '4px', fontFamily: 'SimSun, sans-serif', fontWeight: 'normal' }}>*</span>
                  {t(`marketingManagement.templateContent`)}
                  <span style={{ color: '#ff4d4f', fontSize: '12px', marginRight: '4px', fontFamily: 'SimSun, sans-serif', fontWeight: 'normal' }}>（内容如有链接，请在链接前后添加空格）</span>
                </div>
              </Col>
              <Col span={24} >
                <Form.Item>
                  <Row gutter={8}>
                    <Col span={24} className='smsTextArea'>
                      <Form.Item name='template' onChange={this.onChangeTemplate} onSelect={this.onSelectTemplate} style={{marginBottom: 0}} >
                        <TextArea ref={ r => this.textAreaRef = r} rows={8} placeholder="内容无需带签名和后缀，链接前后需加空格" style={{width: '100%'}} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <div className='interSum'>
                        {t(`marketingManagement.total1`)}<span style={{color: '#ff5200'}}>{this.state.strNum}</span>{t(`marketingManagement.total2`)}<span style={{color: '#ff5200'}}>{this.state.smsNum}</span>{t(`marketingManagement.total3`)}
                      </div>
                      <div className='insertVariable' onClick={this.onChangeInsertVariable}>
                        <div style={{borderTop: '1px solid #d9d9d9', paddingLeft: 24, paddingTop: 10}}>{t(`marketingManagement.insertVariable`)}</div>
                      </div>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
